/**
 * Static UI seed for the app shell. The signed-in user comes from the auth
 * layer (lib/auth.ts) and conversation history is fetched live
 * (lib/conversations.ts); this holds only the few static bits that remain.
 * Curated empty-state prompt sets live in `data/prompts.ts`.
 */

/**
 * Static design default for the signal-bubble backdrop (Login art + empty-state
 * hero). The prototype's tweak panel that toggled this is design-only tooling.
 */
export const SIGNAL_BUBBLES = true;

export function greeting(): string {
  const h = new Date().getHours();
  return h < 12 ? 'Good morning' : h < 18 ? 'Good afternoon' : 'Good evening';
}
